import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { formatedDateClient } from '../../Functions/convertDate';
import { exportTListResidentExcel } from '../../Functions/exportListResidentExcel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons'; 

import '../../Css/FactureEtablie.css';

const FacturesTable = () => {
    const [factures, setFactures] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [filters, setFilters] = useState({
        organisme: "",
        id_facture: "",
        hotel: "",
        nbrfact: "",
        startDate: new Date().toISOString().split('T')[0], 
        endDate: new Date().toISOString().split('T')[0],   
        solde: "",
        passport: "",
        clientName: "",
        clientCheckIn: "",
        clientCheckOut: "",
    });


    const [currentPage, setCurrentPage] = useState(0);
    const [rowspage, setRowsPage ] = useState(12);

    const token = localStorage.getItem('token'); 
    const apiUrl = process.env.REACT_APP_API_URL;





    const handleFilterChange = useCallback(
        (e) => {
            const { name, value } = e.target;
            setFilters((prev) => ({ ...prev, [name]: value }));
        },
        [setFilters]
    );




    const handleDownload = async (documentName) => {
        try {
          const response = await fetch(`${apiUrl}/api/facturation/documents/${documentName}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });
      
          if (!response.ok) {
            throw new Error('Failed to fetch the document');
          }
          const fileBlob = await response.blob();
          const fileURL = URL.createObjectURL(fileBlob);
          window.open(fileURL, '_blank');
      
        } catch (error) {
          console.error('Error while fetching the document:', error);
        } finally {
          setLoading(false);
        }
      };







      const handleKeyPress = useCallback((event) => {
        if (event.key === 'Enter') {
          fetchData();
        }
      },);
    
      useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);
    
        return () => {
          window.removeEventListener('keydown', handleKeyPress);
        };
      }, [handleKeyPress]);


          // Handle change Montant_achat field
    const handleRowsPageChange = (e) => {
        let value = e.target.value;
         setRowsPage(value);
    };
    





    const fetchData = async () => {
        setLoading(true);
        setError(null); 

        try {
            const params = new URLSearchParams();
            Object.keys(filters).forEach(key => {
                if (filters[key]) {
                    params.append(key, filters[key]);
                }
            });

            const facturesRes = await fetch(`${apiUrl}/api/facture/documents?${params.toString()}`, {
                    headers: { 'Authorization': `Bearer ${token}` },
            });
            if (!facturesRes.ok ) {
                throw new Error("Failed to fetch data");
            }
            const facturesData = await facturesRes.json();
        
            if(facturesData.length > 0){
                setCurrentPage(1);
            }
            setFactures(facturesData);
            
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };




    
    const handleSearchClick = () => {
        fetchData();
    };



    useEffect(() => {
        fetchData();
    }, []);




        const paginateData = useMemo(() => {
                const sortedFactures = [...factures].sort((a, b) => {
                    return new Date(b.createdAt) - new Date(a.createdAt);
                });
            
                const startIndex = (currentPage - 1) * rowspage;
                const endIndex = startIndex + rowspage;
                return sortedFactures.slice(startIndex, endIndex);
        }, [factures, currentPage]);

    // Handle pagination buttons (Next, Prev, etc.)
    const totalPages = Math.ceil(factures.length / rowspage);
    const goToPage = (page) => setCurrentPage(page);

    // Disable Prev/Next if no data
    const isPrevDisabled = currentPage === 1 || factures.length === 0;
    const isNextDisabled = currentPage === totalPages || factures.length === 0;



    const handleDeleteFile = async (factureId,fileName,fileReference) => {

        if (window.confirm('Are you sure you want to delete this document?')) {

        try {
          const response = await fetch(`${apiUrl}/api/delete-file/fact/${factureId}/${fileName}/${fileReference}`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          });

          fetchData();
    
          if (!response.ok) {
            alert("document not found");
          }
    
        } catch (err) {
          setError(err.message);
        }
    };
    };


      
    if (loading) {
        return (
            <div className="loader">
                <div className="spinner"></div>
            </div>
        );
    }

    if (error) {
        return <div className='Facturetablie__ErrorAPI'>Error: {error}</div>;
    }

    // Action handlers
    const exportTableInExcel = () => exportTListResidentExcel(factures);

    return (
        <div className="Facturetablie">
    <h2 className="Facturetablie__title">Documents Archivés / Factures</h2>

    <div className="Facturetablie__filterSection1">
        <div className='Facturetablie__SearchDtate'>
            <div className="Facturetablie__filterGroup">
                <label htmlFor="startDate">Start Date</label>
                <input
                   type="date"
                   id="startDate"
                   className="Facturetablie__filterInput"
                   name="startDate"
                   value={filters.startDate}
                   onChange={handleFilterChange}
                />
            </div>
            <div className="Facturetablie__filterGroup">
                <label htmlFor="endDate">End Date</label>
                <input
                   type="date"
                   id="endDate"
                   className="Facturetablie__filterInput"
                   name="endDate"
                   value={filters.endDate}
                   onChange={handleFilterChange}
                />
            </div>
        </div>
        <div className='Facturetablie__filterSection'>
            {[
               { filter: "organisme", label: "Organisme" },
               { filter: "NFacture", label: "N° Facture" },
               { filter: "hotel", label: "Hôtel" },
               { filter: "nbrfact", label: "N° Fct Achat" },
            ].map(({ filter, label, index }) => (
        <div 
            className="Facturetablie__filterGroup1" 
            key={index}
        >
            <label htmlFor={label}>{label}</label>
            <input
                className="Facturetablie__filterInput"
                type={filter === 'clientCheckIn' || filter === 'clientCheckOut' ? 'date' : 'text'}
                name={filter}
                id={filter}
                value={filters[filter]}
                onChange={handleFilterChange}
            />
        </div>
    ))}
</div>

        <button className="Facturetablie__searchButton" onClick={handleSearchClick}>Search</button>
    </div>

    <div className="Facturetablie__exportation">
        <button className="Facturetablie__exportButton" onClick={exportTableInExcel}>Exporter en Excel</button>
    </div>



    {/* Pagination */}
    <div className='Facturetablie__paginationarea'>
        <div className="Facturetablie__pagination">
           <button disabled={isPrevDisabled} onClick={() => goToPage(currentPage - 1)}>&lt; Prev</button>
           <span>Page {currentPage} of {totalPages}</span>
           <button disabled={isNextDisabled} onClick={() => goToPage(currentPage + 1)}>Next &gt;</button>

           <input
            type="text"
            className="Facturetablie__rowspage"
            value={rowspage}
            onChange={handleRowsPageChange}
        />
        </div>
    </div>

            <table className="Facturetablie__table">
                <thead>
                    <tr className="Facturetablie__headerRow">
                        {[
                            { name: "date", label: "Date Création" },
                            { name: "organisme", label: "Organisme" },
                            { name: "hotel", label: "Hôtel" },
                            { name: "nbrfact", label: "N° Fct Hôtel" },
                            { name: "id_facture", label: "N° Facture" },
                            { name: "filenames", label: "Nom du fichier" },
                            { name: "docUrls", label: "Actions" },
                        ].map(({ name, label }) => (
                            <th key={name}>{label}</th>
                        ))}
                    </tr>
                </thead>

                <tbody>
    {paginateData.length > 0 ? (
        paginateData.map((item) =>
            item.filenames.length > 0 ? (
                item.filenames.map((file, index) => (
                    <tr key={`${item.id_facture}-${index}`}>
                        {index === 0 && (
                            <>
                                <td rowSpan={item.filenames.length}>{formatedDateClient(item.currentDate)}</td>
                                <td rowSpan={item.filenames.length}>{item.selectedorganisme}</td>
                                <td rowSpan={item.filenames.length}>{item.selectedHotel}</td>
                                <td rowSpan={item.filenames.length}>{item.nbrfact}</td>
                                <td rowSpan={item.filenames.length}>{item.id_facture}</td>
                            </>
                        )}
                        {file ? (
                            <td>{file}</td>
                        ) : (
                            <td>No filename</td>  // If filename is empty, show 'No filename'
                        )}
                        <td>            
                            <button 
                                onClick={() => handleDownload(item.docUrls[index])}
                                style={{ 
                                    background: 'none', 
                                    border: 'none', 
                                    padding: '0', 
                                    cursor: 'pointer',
                                    color: '#4A90E2'
                                }}
                            >
                                <FontAwesomeIcon 
                                    icon={faPrint} 
                                    style={{ fontSize: '18px', marginRight: '8px' }} 
                                />
                            </button>
                            <button onClick={() => handleDeleteFile(item.id_facture, file, item.docUrls[index])}>Delete</button>
                        </td>
                    </tr>
                ))
            ) : null
        )
    ) : (
        <tr><td colSpan="10" className='not-found'>No results found.</td></tr>
    )}
</tbody>

            </table>
</div>

    );
};

export default FacturesTable;




